import axios from 'axios'
import request from './index'

export const getCarList = (pageIndex, pageSize, payType) => {
  return request({
    url: '/index/doPage/' + pageIndex + '/' + pageIndex + '/' + payType,
    method: 'get',

  })
}

export const getCarById = (carId, payType) => {
  return request({
    url: '/index/getCarById/' + carId + '/' + payType,
    method: 'get',
  })
}

export const doAction = actionObject => {
  return request({
    url: '/index/doAction',
    method: 'post',
    data: {
      action: actionObject.action,
      ids: actionObject.idList
    }
  })
}

export const carSave = (type, carForm) => {
  return request({
    url: '/car/carSave',
    method: 'post',
    data: {
      type: type,
      carNumber: carForm.addNumber,
    }
  })
}

export const carEdit = (type, carForm) => {
  return request({
    url: '/car/carEdit',
    method: 'post',
    data: {
      type: type,

      id: carForm.addId,
      name: carForm.addName,
      typeName: carForm.addTypeName,
      addType: carForm.addType,
      carNumber: carForm.addNumber,
      longitude: carForm.addLongitude,
      latitude: carForm.addLatitude,
      status: carForm.addStatus,
      statusStr: carForm.addStatusStr,
      createTime: carForm.addCreateTime,
      createTimeStr: carForm.addCreateTimeStr,
    }
  })
}

export const getVirtualCarList = (listQuery, pageIndex, pageSize, payType) => {
  return request({
    url: '/car/getVirtualCarList/',
    method: 'post',
    data: {
      listQuery: listQuery,
      pageIndex: pageIndex,
      pageSize: pageSize,
      type: payType
    }
  })
}

export const deleteCarController = (carId) => {
  return request({
    url: '/car/deleteCar/' + carId,
    method: 'get',

  })
}

export const deleteAllCar = () => {
  return request({
    url: '/car/deleteAllCar',
    method: 'get',
  })
}

export const getCarTypeAllList = () => {
  return request({
    url: '/car_type/getCarTypeAllList',
    method: 'get',

  })
}

export const carTypeSave = carTypeForm => {
  return request({
    url: '/car_type/carTypeSave',
    method: 'post',
    data: {
      id: carTypeForm.addtypeId,
      entityId: carTypeForm.addtypeEntityId,
      name: carTypeForm.addtypeName,
      length: carTypeForm.addtypeLength,
      width: carTypeForm.addtypeWidth,
      height: carTypeForm.addtypeHeight,
      weight: carTypeForm.addtypeWeight,
      carCost: carTypeForm.addtypeCarCost,
      insurance: carTypeForm.addtypeInsurance,
      maintenanceFees: carTypeForm.addtypeMaintenanceFees,
      chargingFee: carTypeForm.addtypeChargingFee,
      invoiceTax: carTypeForm.addtypeInvoiceTax,
      deposit: carTypeForm.addtypeDeposit,
      dailyFee: carTypeForm.addtypeDailyFee,
      monthlyFee: carTypeForm.addtypeMonthlyFee,
      annualFee: carTypeForm.addtypeAnnualFee
    }
  })


}

export const getCarTypeList = (listQuery, pageIndex, pageSize) => {
  return request({
    url: '/car_type/getCarTypeList/',
    method: 'post',
    data: {
      listQuery: listQuery,
      pageIndex: pageIndex,
      pageSize: pageSize,

    }
  })
}



export const carTypeEdit = (carTypeForm) => {
  return request({
    url: '/car_type/carTypeEdit',
    method: 'post',
    data: {
      id: carTypeForm.addtypeId,
      entityId: carTypeForm.addtypeEntityId,
      name: carTypeForm.addtypeName,
      length: carTypeForm.addtypeLength,
      width: carTypeForm.addtypeWidth,
      height: carTypeForm.addtypeHeight,
      weight: carTypeForm.addtypeWeight,
      carCost: carTypeForm.addtypeCarCost,
      insurance: carTypeForm.addtypeInsurance,
      maintenanceFees: carTypeForm.addtypeMaintenanceFees,
      chargingFee: carTypeForm.addtypeChargingFee,
      invoiceTax: carTypeForm.addtypeInvoiceTax,
      deposit: carTypeForm.addtypeDeposit,
      dailyFee: carTypeForm.addtypeDailyFee,
      monthlyFee: carTypeForm.addtypeMonthlyFee,
      annualFee: carTypeForm.addtypeAnnualFee
    }
  })
}

export const deleteCarTypeController = (id) => {
  return request({
    url: '/car_type/deleteCarType/' + id,
    method: 'get',

  })
}

export const totalList = (listQuery) => {
  return request({
    url: '/statistics/total_list',
    method: 'post',
    data: {
      currentpage: listQuery.pageIndex,
      totalRecord: listQuery.pageSize,
      startDate: listQuery.time[0],
      endDate: listQuery.time[1],
    }
  })
}

export const updateCarType = (carId, type) => {
  return request({
    url: '/remote/updateCarType/' + carId + '/' + type,
    method: 'get',

  })
}

